import React, { useState, useEffect } from 'react';
import { Button, Paper, Typography, TextField, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { createPurity, updatePurity } from '../../redux/actions/purity/purityAction';
import { toast } from 'react-toastify';

const PurityForm = ({ selectedPurity, onReset }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: '',
    hm_purity: 0.00,
  });

  useEffect(() => {
    if (selectedPurity) {
      setFormData({
        name: selectedPurity.name || '',
        hm_purity: selectedPurity.hm_purity !== undefined ? selectedPurity.hm_purity : 0.00,
      });
    } else {
      setFormData({ name: '', hm_purity: 0.00 });
    }
  }, [selectedPurity]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (selectedPurity) {
        await dispatch(updatePurity(selectedPurity.id, formData));
        toast.success('Purity updated successfully');
      } else {
        await dispatch(createPurity(formData));
        toast.success('Purity created successfully');
      }
      setFormData({ name: '', hm_purity: 0.00 });
      if (onReset) onReset();
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || 'An error occurred while processing purity';
      toast.error(errorMessage);
    }
  };

  const handleClear = () => {
    setFormData({ name: '', hm_purity: 0.00 });
    if (onReset) onReset();
  };

  return (
    <Paper elevation={3} sx={{ p: 3, boxShadow: 'none', background: 'transparent'  }}>
      <Typography variant="h6" sx={{ fontWeight: 'bold' }} gutterBottom>
        {selectedPurity ? 'Edit Purity' : 'Add Purity'}
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Purity"
          name="name"
          value={formData.name}
          onChange={handleChange}
          margin="normal"
          required
          autoComplete="off"
        />
        <TextField
          fullWidth
          label="HM Purity"
          name="hm_purity"
          type="number"
          value={formData.hm_purity}
          onChange={handleChange}
          margin="normal"
          inputProps={{ step: '0.01' }}
          required
        />
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          <Button type="submit" variant="contained" color="primary" fullWidth>
            {selectedPurity ? 'Update' : 'Add'}
          </Button>
          <Button 
            type="button" 
            variant="outlined" 
            color="primary" 
            fullWidth
            onClick={handleClear}
          >
            Clear
          </Button>
        </Box>
      </form>
    </Paper>
  );
};

export default PurityForm;
